import React from "react";



export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro" style={{ border: "none"}}>
        <div className="overlay">
          <div className="container">
            <div className="" style={{textAlign: "center"}}>
              <div className="col-md-8 col-md-2 intro-text" style={{marginLeft: "auto", marginRight: "auto"}}>
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="#features"
                  className="btn btn-customm btn-lg page-scroll"
                  style={{border:"none"}}
                >
                  Book now
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
